import React from "react";
import { buildNotifyTrigger } from "@coveo/headless";
import { useCoveoController } from "./utils";
import { Auth0Notification } from "@a0/support-center-components";

export const Notifications = () => {
  const { state } = useCoveoController(
    (headlessEngine) => buildNotifyTrigger(headlessEngine),
    "NotifyTrigger"
  );

  const { notifications } = state;
  if (!notifications || !notifications.length) {
    return null;
  }
  return notifications.map((notification) => (
    <Auth0Notification key={notification} type="primary">
      <p>{notification}</p>
    </Auth0Notification>
  ));
};
